module.exports = __webpack_public_path__ + "static/img/cop_sch_logo20.45fb0952.png";